const strings = {
    contentToolTip : 'Type the body of the tweet',
    urlToolTip : 'Type the url you wish to share with the tweet',
    hashtagsToolTip : 'Type the hashtags as comma separated values',
    usernameToolTip : 'Type the username you wish to tag in the tweet',
    placeholders : {
        name : 'Enter username (if any)',
        hashtags : 'Enter hashtags as csv',
        url : 'Enter URL (if any)',
        content : 'Enter your text',
    }
}

export default strings;